import React from 'react';

const Loading = () => {
    return (
        <div>
            <progress className="progress w-56"></progress>
        </div>
    );
};

export default Loading;